import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { api } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { BookMarked, Search } from 'lucide-react';

export default function Pgc() {
  const { t } = useI18n();
  const [accounts, setAccounts] = useState([]);
  const [q, setQ] = useState('');
  const load = useCallback(async () => { const r = await api.get('/pgc-accounts'); setAccounts(r.data); }, []);
  useEffect(() => { load(); }, [load]);
  const filtered = useMemo(() => {
    if (!q) return accounts;
    const lq = q.toLowerCase();
    return accounts.filter(a => a.codigo.includes(lq) || a.nombre.toLowerCase().includes(lq));
  }, [accounts, q]);
  const grouped = useMemo(() => {
    const g = {};
    filtered.forEach(a => { if (!g[a.grupo]) g[a.grupo] = []; g[a.grupo].push(a); });
    return g;
  }, [filtered]);
  return (
    <div className="space-y-4" data-testid="pgc-page">
      <div className="flex items-center gap-3">
        <BookMarked className="h-6 w-6 text-[hsl(var(--primary))]" />
        <div>
          <h1 className="text-2xl font-heading font-bold">{t('pgc_chart')}</h1>
          <p className="text-xs text-[hsl(var(--muted-foreground))]">{accounts.length} cuentas • Plan General Contable PYMES (España)</p>
        </div>
      </div>
      <div className="relative max-w-md">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[hsl(var(--muted-foreground))]" />
        <Input value={q} onChange={e => setQ(e.target.value)} placeholder={t('search') + '...'} className="pl-9" data-testid="pgc-search-input" />
      </div>
      <div className="space-y-3">
        {Object.keys(grouped).sort().map(g => (
          <Card key={g}>
            <CardContent className="p-3">
              <h2 className="font-heading font-semibold text-sm uppercase tracking-wider text-[hsl(var(--muted-foreground))] mb-2">{t('pgc_group')} {g}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1.5">
                {grouped[g].map(a => (
                  <div key={a.codigo} className="flex items-start gap-2 p-2 rounded-lg hover:bg-[hsl(var(--muted))]" data-testid={`pgc-account-${a.codigo}`}>
                    <Badge variant="outline" className="font-mono shrink-0 text-xs">{a.codigo}</Badge>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm leading-tight">{a.nombre}</div>
                      {a.tipo && <div className="text-[10px] text-[hsl(var(--muted-foreground))] uppercase mt-0.5">{a.tipo}</div>}
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
